import 'react-toastify/dist/ReactToastify.css';

let db: any;
let proceso = process.env
const indexedDB = window.indexedDB;
const tableMinutaFood = "minutaFood"
const version: any = proceso.REACT_VERSION_DB || 1;
const nameDB: any = "sodexo";
if (indexedDB) {
    const request = indexedDB.open(nameDB, version);
    request.onsuccess = () => {
        db = request.result;
    }
    request.onupgradeneeded = () => {
        db = request.result;
        const store = db.createObjectStore(tableMinutaFood, {
            keyPhat: "dataMinuta", autoIncrement: true
        });
        // create an index on the email property

    }
    request.onerror = (error) => {
    }
}

export const saveDataMinutaFood = (data: any) => {
    setTimeout(async () => {
        if (data === "[]") {
            await clearData(); return;
        }
        const txn = db.transaction(tableMinutaFood, 'readwrite')
        const store = txn.objectStore(tableMinutaFood);
        let query2 = await store.clear();
        //
        query2.onsuccess = function (event: any) {
            let query = store.put({ minutaData: data });
            query.onsuccess = function (event: any) {
            };
            query.onerror = function (event: any) {
            }
        };
    }, 500);
}
export const deleteDataMinuta = (id: number) => {
    // create a new transaction
    const txn = db.transaction(tableMinutaFood, 'readwrite');
    const store = txn.objectStore(tableMinutaFood);
    //
    let query = store.delete(id);
    query.onsuccess = function (event: any) {
    };
    query.onerror = function (event: any) {
    }
}
export const getDataMinuta = () => {
    const txn = db.transaction(tableMinutaFood);
    const store = txn.objectStore(tableMinutaFood);

    let query = store.getAll();

    query.onsuccess = (event: any) => {
        if (!event.target.result) {
        } else {
        }
    };

    query.onerror = (event: any) => {
    }
    return query
}
export const clearData = () => {
    // open a read/write db transaction, ready for clearing the data
    try {
        const transaction = db.transaction([tableMinutaFood], "readwrite");

        // report on the success of the transaction completing, when everything is done
        transaction.oncomplete = (event: any) => {

        };

        transaction.onerror = (event: any) => {
        };

        // create an object store on the transaction
        const objectStore = transaction.objectStore(tableMinutaFood);

        // Make a request to clear all the data out of the object store
        const objectStoreRequest = objectStore.clear();

        objectStoreRequest.onsuccess = (event: any) => {
        };
    } catch (error) {

    }
}